import { render, staticRenderFns } from "./ForexReviewModal.vue?vue&type=template&id=180b1671"
import script from "./ForexReviewModal.vue?vue&type=script&lang=js"
export * from "./ForexReviewModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports